export default function updateDocument(ref, data) {
	return ref.update(data);
}
